/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} New_Project_Confirm_Step_HeadingInputs */



/**
* | output |
* | --- |
* | "Review your settings" |
*
* @param {New_Project_Confirm_Step_HeadingInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const new_project_confirm_step_heading = /** @type {((inputs?: New_Project_Confirm_Step_HeadingInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<New_Project_Confirm_Step_HeadingInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Vérifiez vos paramètres")
	if (locale === "de") return /** @type {LocalizedString} */ ("Überprüfen Sie Ihre Einstellungen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Rivedi le tue impostazioni")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Проверьте свои настройки.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Revisa tu configuración")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("查看您的设置")
	if (locale === "ja") return /** @type {LocalizedString} */ ("設定を確認してください")
	if (locale === "hi") return /** @type {LocalizedString} */ ("अपनी सेटिंग्स की समीक्षा करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Revise suas configurações")
	return /** @type {LocalizedString} */ ("Review your settings")
});